<template>

  <div class="uk-animation-fade" ref="container">

    <h3 v-html="labels['resultsSectionTitle']" class="uk-h3 uk-margin-bottom"></h3>

    <div class="kmc-calc-results-box ">
      <div class="uk-flex uk-flex-center uk-flex-column uk-padding">
        <div class="uk-margin-small uk-text-bold" v-html="labels['amountYouCanBorrowLabel']"></div>
        <div class="primary-amount">{{ formatCurrency(data['calculator_output']['maximum_balance'], true) }}</div>
      </div>

      <div class="uk-flex uk-child-width-1-2">
        <div class="uk-padding">
          <div class="uk-margin-small" v-html="labels['yourDepositLabel']"></div>
          <div class="amount"> {{ formatCurrency(data['request']['deposit'], true) }}</div>
        </div>
        <div class="uk-padding">
          <div class="uk-margin-small" v-html="labels['propertyValueLabel']"></div>
          <div class="amount">{{ formatCurrency(data['request']['property_valuation'], true) }}</div>
        </div>
      </div>
    </div>

    <div v-html="labels['resultsBody1']" class="uk-margin uk-margin-medium-bottom"></div>


    <a class="uk-display-block kmc-color-2 uk-text-center uk-text-uppercase" @click="recalculate"><u v-text="labels['recalculateBtnLabel']"></u></a>

    <hr style="border-top-width: 1px;" class="uk-margin-medium"/>

    <div v-html="labels['resultsBody2']" class="uk-margin"></div>

    <div v-if="isBusinessHours" class="uk-text-center">
      <a class="uk-button uk-button-primary uk-button-large uk-border-pill uk-text-bold uk-width-1-1 uk-margin"
         :href="labels['callLikeBtnLink']"
         v-text="labels['callLikeBtnLabel']"></a>
      <span> or </span>
    </div>
    <a
        class="uk-button uk-button  uk-text-bold uk-width-1-1 uk-margin uk-text-uppercase"
        :class="{'uk-button-primary' : !isBusinessHours, 'uk-button-link': isBusinessHours}"
        @click="$emit('requestLikeCallback')"
        v-text="labels['requestLikeCallbackBtnLabel']"></a>
    <div v-html="labels['resultsBody3']" class="uk-margin"></div>
  </div>

</template>

<script>

import {formatCurrency} from "../util";
import {onMounted, ref} from "vue";
import {isLikeBusinessHours} from "../util/like";

export default {
  name: "KmcCalculatorResult",
  emits: ['recalculate', 'requestLikeCallback'],
  props: {
    labels: {
      type: Object
    },
    data: {
      type: Object,
    },
  },
  setup: function (props, context) {

    const container = ref(null)
    const labels = props.labels;

    onMounted(() => {
      setTimeout(() => window.scrollTo(0, 0), 0)

      if (window.decClientReady) {
        initMortgageGymUTMParams()
      }
    })

    const recalculate = () => {
      history.back()
      context.emit('recalculate')
    }

    const isBusinessHours = isLikeBusinessHours();

    return {
      container,
      labels,
      formatCurrency,
      recalculate,
      isBusinessHours
    };
  }
}

</script>

